module.exports = __webpack_public_path__ + "static/media/session-timeout.b482e545.png";